module.exports = __webpack_public_path__ + "img/dice-yxx3-1.a27302c5.svg";